import React from 'react';

import IUserGroup from '../interfaces/IUserGroup';
import List from '../components/List/List';

interface Props {
  userGroups: IUserGroup[];
  setUserGroups: React.Dispatch<React.SetStateAction<IUserGroup[]>>;
}

const UserGroup: React.FC<any> = ({ userGroups, setUserGroups }: Props) => {
  const handleUpdateUserGroup = (
    seqGrupo: number,
    membroGrupo: boolean
  ): void => {
    setUserGroups((records) => [
      ...records.map((record) => {
        if (record.seqGrupo === seqGrupo) {
          return {
            ...record,
            membroGrupo: membroGrupo ? 'S' : 'N',
          };
        }
        return record;
      }),
    ]);
  };

  return (
    <div
      className="table-responsive overflow-hidden"
      style={{
        borderRadius: '0.68rem',
        borderColor: 'transparent',
      }}
    >
      <div
        className="w-100 text-white p-2"
        style={{ backgroundColor: '#1A1A1A' }}
      >
        <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
          Grupos vinculados ao usuário
        </span>
      </div>
      <div
        className="rounded w-100 border-0 overflow-auto"
        style={{
          height: '19rem',
        }}
      >
        <List
          key="user-group-list"
          data={userGroups}
          handleUpdateRegister={handleUpdateUserGroup}
          idField="seqGrupo"
          nameField="nomeGrupo"
          checkedField="membroGrupo"
        />
      </div>
    </div>
  );
};

export default UserGroup;
